import { notification, Spin } from 'antd';
import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

import Modal from '../../shared/Modal';
import Store from './Store';
import customFetch from '../../../utils/customFetch';

class ModalImport extends React.Component {
  state = { files: null, errorMessage: '' };

  uploadFileTemplate = body => {
    return customFetch('/MBSCode/ImportMBSCode', {
      method: 'POST',
      body,
    });
  };
  handleUpload = event => {
    const files = event.target.files;
    if (!files || !files.length) {
      return;
    } else {
      const file = files[0];
      const type = /[.]/.exec(file.name) ? /[^.]+$/.exec(file.name)[0] : undefined;
      const size = file.size / 1024 / 1024;
      if (size > 5) {
        notification.destroy();
        return notification.error({
          message: 'Error',
          description: 'The file you have selected is too large. The maximum size is 5MB.',
        });
      } else if (type === 'xls' || type === 'xlsx') {
        Store.setLoadingUpload(true);
        const formData = new FormData();
        formData.append(files[0].name, files[0]);
        this.uploadFileTemplate(formData)
          .then(res => {
            Store.setLoadingUpload(false);
            window.open(res.FilePath, '_blank');
            if (res.status === 'success') {
              notification.destroy();
              notification.success({
                message: 'Success',
                description: 'Upload file successfully',
              });
              return Store.toggleModal(false, {})();
            } else {
              notification.destroy();
              return notification.error({
                message: 'Error',
                description: 'Upload file failed',
              });
            }
          })
          .catch(() => {});
      } else {
        notification.destroy();
        return notification.error({
          message: 'Error',
          description: 'File type not permitted',
        });
      }
    }
  };

  handleDowloadTemplate = () => {
    window.open('/MBSCode/DownloadTemplate', '_blank');
  };
  onCancel = () => {
    return Store.toggleModal(false, {})();
  };
  render() {
    const { toggleModal, open, modalParams, loadingUpload } = Store;
    return (
      <React.Fragment>
        <Modal
          visible={open}
          width={1200}
          onCancel={toggleModal(false)}
          title={`Import AMA/MBS Codes`}
          footer={
            <React.Fragment>
              <Button className="negative" onClick={this.onCancel}>
                Close
              </Button>
            </React.Fragment>
          }
        >
          {!this.state.files || !this.state.files.length ? (
            <div className="Modal-UploadProfilePicture loading-container">
              <div className="mb-1">
                <p>
                  You can upload one .XLSX file only. Max file size is{' '}
                  {modalParams.type === 1 ? <span>5 MB</span> : <span>500 records</span>}.
                </p>
                <label
                  className="Button"
                  style={{ marginRight: '10px', minWidth: '205px' }}
                  onClick={this.handleDowloadTemplate}
                >
                  <Icon name="download" />
                  <span className="title">Download Template</span>
                </label>
                <label className="Button" style={{ minWidth: '205px' }}>
                  <Icon name="upload" />
                  <span className="title-download">Upload</span>
                  <input hidden type="file" onChange={this.handleUpload} />
                </label>
              </div>
            </div>
          ) : null}
          <div className={loadingUpload ? 'uploadcm-loading' : ''}>
            {loadingUpload && <Spin style={{ margin: '0 auto' }} size="large" />}
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}
export default ModalImport;
